import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: ["mx-auto text-black editor-certificate"],

    editor: ["rounded overflow-hidden relative mx-auto"],
    editorHeader: ["flex justify-between items-center mb-10"],
    editorContent: [
      "bg-gray-100/80 backdrop-blur-md p-8 rounded-xl h-full relative z-10 flex justify-between flex-col",
    ],
    contentCertificateLogo: ["relative flex items-center w-[160px] min-h-[48px] overflow-hidden border-none"],
    certificateLogo: ["absolute w-full object-cover"],
    header: ["border-t"],
    background: ["absolute inset-0"],
    menuItem: ["transition-all duration-200 p-1 cursor-pointer hover:opacity-80"],
    btnOrientationActive: ["border-1 hover:border-primary-300 hover:border-2"],
    controlsWrapper: ["absolute inset-0 z-10"],

    signature: [
      "relative before:content[''] before:border-b before:border-dashed before:absolute before:border-gray-900 before: before:bottom-0 before:inset-x-0 px-5",
    ],
    signatureText: ["text-[10px]"],
    logo: ["w-[160px] h-[48px] !text-black absolute bottom-12 right-14 z-10"],
    inputControlPrimary: [],
    inputControlSecondary: [],
    inputControlTertiary: [],
  },
  variants: {
    editMode: {
      true: {
        editor: ["border-3 border-gray-900 border-dotted"],
      },
    },
    selectedOrientation: {
      true: {
        btnOrientationActive: ["border-2 border-fx-primary"],
      },
      false: { btnOrientationActive: ["border-neutral-300"] },
    },
    orientation: {
      Landscape: {},
      Portrait: {},
    },
  },
  compoundSlots: [
    {
      slots: ["editor"],
      orientation: "Landscape",
      class: "h-[633px] w-[812px]",
    },
    {
      slots: ["editor"],
      orientation: "Portrait",
      class: "h-[812px] w-[633px]",
    },

    {
      slots: ["base"],
      orientation: "Landscape",
      class: "w-[812px]",
    },
    {
      slots: ["base"],
      orientation: "Portrait",
      class: "w-[633px]",
    },

    // Landscape theme
    {
      slots: ["inputControlPrimary"],
      orientation: "Landscape",
      class: "absolute text-center right-20 top-16",
    },
    {
      slots: ["inputControlSecondary"],
      orientation: "Landscape",
      class: "absolute text-center transform -translate-x-1/2 left-1/2 bottom-28",
    },
    {
      slots: ["inputControlTertiary"],
      orientation: "Landscape",
      class: "absolute text-center left-20 top-16",
    },

    // Portrait theme
    {
      slots: ["inputControlPrimary"],
      orientation: "Portrait",
      class: "absolute text-center top-16 left-24",
    },
    {
      slots: ["inputControlSecondary"],
      orientation: "Portrait",
      class: "absolute text-center transform -translate-y-1/2 top-1/2 right-28",
    },
    {
      slots: ["inputControlTertiary"],
      orientation: "Portrait",
      class: "absolute text-center bottom-16 left-24",
    },
  ],
});
